import ReactFullpage from "@fullpage/react-fullpage";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import styled from "styled-components";
import SwiperCore from "swiper";
import "swiper/css";
import { Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { ReactComponent as About } from "../assets/svg/about.svg"
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Header from '../components/global/Header';
import Intro from '../components/start/Intro';
import { useDispatch, useSelector } from "react-redux";
import { setHeaderTheme } from '../store/headerSlice';
import Footer from "../components/global/Footer";
import ScrollBtn from "../components/global/ScrollBtn";
import Portfolio from "../components/start/MainPortfolio";
import Address from "../components/start/Address";

SwiperCore.use([Mousewheel]);

const Start = () => {
  const swiperRef = useRef(null);
  const location = useLocation();
  const fullpageRef = useRef(null);

  const [wheelAllow, setWheelAllow] = useState(true);
  const [swiperAllow, setSwiperAllow] = useState({
    up: false,
    down: false,
  });

  const theme = useSelector((state) => state.header.theme);
  const open = useSelector((state) => state.open.boolean);

  const dispatch = useDispatch();


  const checkSwiper = (swiper) => {
    const idx = swiper.realIndex;
    const slides = swiper.slides;
    const length = slides.length;
    if (idx === 0) {
      setSwiperAllow({ up: true, down: false });
    } else if (idx === length - 1) {
      setSwiperAllow({ up: false, down: true });
    } else {
      setSwiperAllow({ up: false, down: false });
    }
    if (length === 0) {
      setSwiperAllow({ up: true, down: true });
    }
  };

  const swiperOptions = {
    slidesPerView: 1.5,
    spaceBetween: 0,
    freeMode: false,
    speed: 1000,
    centeredSlides: true,
    mousewheel: true,
    onSlideChangeTransitionStart: () => {
      setWheelAllow(false);
    },
    onSlideChangeTransitionEnd: () => {
      setWheelAllow(true);
    },
    onSlideChange: (swiper) => {
      checkSwiper(swiper);
    },
    onSwiper: (swiper) => {
      checkSwiper(swiper);
    },
  };

  useEffect(() => {
    const newTheme = location.hash === "#sec2" || location.hash === "#sec4" ? "black" : "white";
    dispatch(setHeaderTheme(newTheme));
  }, [dispatch, location.hash]);

  // useEffect(()=>{
  //   if (fullpageRef.current) {
  //     fullpageRef.current.fullpageApi.moveTo(1);
  //   }
  // },[fullpageRef]);

  const fullpageOptions = {
    scrollingSpeed: 1000,
    anchors: ["sec1", "sec2", "sec3", "sec4"],
  };

  return (
    <HelmetProvider>
      <StartWrap>
        <Helmet>
          <title>토핑 - 웹/앱/플랫폼 전문 개발 회사</title>
          <meta name="description" content="다양한 개발스택을 보유한 웹/앱/플랫폼 전문 개발 회사입니다. 컨설팅부터 개발, 운영, 유지보수까지 토탈 솔루션을 제공합니다." />
          <meta name="keywords" content="웹개발,앱개발,플랫폼개발,IT컨설팅,시스템운영,유지보수" />
          <meta property="og:title" content="토핑 - 웹/앱/플랫폼 전문 개발 회사" />
          <meta property="og:description" content="다양한 개발스택을 보유한 웹/앱/플랫폼 전문 개발 회사입니다. 컨설팅부터 개발, 운영, 유지보수까지 토탈 솔루션을 제공합니다." />
        </Helmet>
        <Header theme={theme} />
        <ReactFullpage
          ref={fullpageRef}
          {...fullpageOptions}
          render={({ state, fullpageApi }) => (
            <ReactFullpage.Wrapper>
              <div className="section sec1">
                <Intro />
              </div>
              <div
                className="section aboutWrap sec2"
                onWheel={(e) => {
                  if (wheelAllow === false) {
                    e.stopPropagation();
                    return;
                  }
                  if (e.deltaY > 0) {
                    if (swiperAllow.down === false) {
                      e.stopPropagation();
                    }
                  } else {
                    if (swiperAllow.up === false) {
                      e.stopPropagation();
                    }
                  }
                }}
              >
                <About className="aboutBg" />
                <Swiper {...swiperOptions} ref={swiperRef}>
                  <SwiperSlide className="swiper1">
                    <div className="action">
                      <h2 className="title">
                        다양한 개발스택을 보유하고 있습니다.
                      </h2>
                      <p className="introText">
                        It has a variety of development techniques.
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiper2">
                    <h2 className="title">
                      컨설팅부터 개발, 운영, 유지보수까지
                    </h2>
                    <p className="introText">
                      From consulting, operating, maintenance,
                    </p>
                  </SwiperSlide>
                  <SwiperSlide className="">
                    <h2 className="title">
                      웹/앱/플랫폼 서비스 개발을 전문 회사입니다.
                    </h2>
                    <p className="introText">
                      It is a company specializing in web and app platform service development.
                    </p>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className="section sec3">
                <Portfolio />
                <Footer theme="white" />
              </div>
              <div className="section sec4 whiteBg">
                <Address />
              </div>
            </ReactFullpage.Wrapper>
          )}
        ></ReactFullpage>
        {location.hash === "#sec1" && open === true || location.hash === "" && open === true ? <ScrollBtn /> : null}
        <Footer theme={theme} position={location.hash === "#sec3" ? "relative" : "fixed"} />
      </StartWrap>
    </HelmetProvider>
  );
};

const StartWrap = styled.div`
  .fp-overflow {
    width: 100%;
    height: 100%;
  }
  .swiper{
    height: 100%;
    .swiper-slide{
      display: flex;
      flex-direction: column;
      justify-content: center;
      transform: scale(0.7);
      align-items: center;
      opacity: 0.7;
      transition: all 0.5s;
    &.swiper-slide-active{
      transform: scale(1);
      opacity: 1;
    }
      .title{
        margin-bottom:20px;
      }
      p{
        color: #000;
      }
    }
  }
  .sec3{
    overflow-y: hidden;
    position: relative;
    height: auto;
    .fp-overflow{
      height: calc(100% - 128px);
    }
    &:-webkit-scrollbar {
      display: none;
    }
  }
  
`;
export default Start;
